import React, { useEffect, useState } from "react";
import { Button, withStyles } from "@material-ui/core/";
import ZipLoader from "./Loader/ZipLoader";

const StyledButton = withStyles({
  root: {
    background: "linear-gradient(45deg, #673ab7 30%, #6a2fd2 90%)",
    borderRadius: 0,
    border: 0,
    color: "white",
    height: 48,
    padding: "0 30px",
    boxShadow: "0 3px 5px 2px #e0e0e0",
  },
  label: {
    textTransform: "uppercase",
  },
})(Button);

const apiBaseURL = {
  staging: "https://stagingapi.mrsziplyneweb.hosts.jhmi.edu",
  prod: "https://api.mrmpzipweb01.hosts.jhmi.edu"
}
const ssoSignIn = () => {
  const baseURL = apiBaseURL.prod;
  let url = `${baseURL}/api/v2/saml/login`;
  popupCenter({ url, title: "Single SignOn", w: 400, h: 400 });
};
const popupCenter = ({ url, title, w, h }) => {
  // Fixes dual-screen position                             Most browsers      Firefox
  const dualScreenLeft =
    window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const dualScreenTop =
    window.screenTop !== undefined ? window.screenTop : window.screenY;

  const width = window.innerWidth
    ? window.innerWidth
    : document.documentElement.clientWidth
    ? document.documentElement.clientWidth
    : window.screen.width;
  const height = window.innerHeight
    ? window.innerHeight
    : document.documentElement.clientHeight
    ? document.documentElement.clientHeight
    : window.screen.height;

  const systemZoom = width / window.screen.availWidth;
  const left = (width - w) / 2 / systemZoom + dualScreenLeft - 300;
  const top = (height - h) / 2 / systemZoom + dualScreenTop;
  const newWindow = window.open(
    url,
    title,
    `
      scrollbars=yes,
      width=${w / systemZoom}, 
      height=${h / systemZoom}, 
      top=${top}, 
      left=${left}
      `
  );
  try {
    if (window.focus) newWindow.focus();
  } catch (err) {
    console.log("Popup blocked");
    alert("Please enable Popup");
  }
};
const Auth = ({ children }) => {
  const [isLogin, setIsLogin] = useState(false);
  const loginByToken = () => {
    try {
      const jwtToken = localStorage.getItem("ziplyne_token");
      if (jwtToken) {
        const [, payload] = jwtToken.split(".");
        const { exp: expires } = JSON.parse(window.atob(payload));
        if (Date.now() >= expires * 1000) {
          // token expired
          // clear local storage values
          let keysToRemove = ["ziplyne_token", "isSAMLLogin", "role", "player_user",'ADString',"companyId"];
          keysToRemove.forEach((key) => {
            localStorage.removeItem(key);
          });
        } else {
          const role = localStorage.getItem("role");
          if (role) {
            setTimeout(() => {
              try {
                if (document.getElementById("ziplyne-player")) {
                  window.$ziplyne.assignSegment(role);
                }
              } catch (error) {
                console.log(error);
              }
            }, 5000);
          }
          setIsLogin(true);
        }
      }
    } catch (error) {}
  };
  useEffect(() => {
    if (localStorage.getItem('isSAMLLogin')) {
      setIsLogin(true);
    } else {
      if (isLogin === false) {
        loginByToken();
      }
    }
  }, [isLogin]);
  useEffect(() => {
    // listen to message sent by auth popup
    window.addEventListener("message", (msg) => {
      var loginResponse = msg.data;
      try {
        if (loginResponse.zipaction.action === "authentication") {
          localStorage.setItem("isSAMLLogin", true);
          setIsLogin(true);
        }
      } catch (exception) {
        console.log(exception);
      }
    });
  }, []);
  return (
    <>
      {isLogin ? (
        children
      ) : (
        <>
          <div className="auth-wrap">
            <p className="auth-title">
              Make sure you are connected to VPN and you are a part of Active
              Directory in order to Sign in
            </p>
            <StyledButton onClick={() => ssoSignIn()}>Sign IN</StyledButton>
          </div>
          <ZipLoader />
        </>
      )}
    </>
  );
};

export default Auth;
